export const GET_SET = 'GET_SET';
export const GET_SET_SUCCESS = 'GET_SET_SUCCESS';
export const GET_SET_ERROR = 'GET_SET_ERROR';

export const OPEN_SET = 'OPEN_SET';
export const CLOSE_SET = 'CLOSE_SET';

export const RESET_SET = 'RESET_SET';

export const DELETE_SET = 'DELETE_SET';
export const DELETE_SET_SUCCESS = 'DELETE_SET_SUCCESS';
export const DELETE_SET_ERROR = 'DELETE_SET_ERROR';

export const SET_CREATE = 'SET_CREATE';
export const SET_CREATE_SUCCESS = 'SET_CREATE_SUCCESS';
export const SET_CREATE_ERROR = 'SET_CREATE_ERROR';

export const BATCH_ADD_TO_SET = 'BATCH_ADD_TO_SET';
export const BATCH_ADD_TO_SET_SUCCESS = 'BATCH_ADD_TO_SET_SUCCESS';
export const BATCH_ADD_TO_SET_ERROR = 'BATCH_ADD_TO_SET_ERROR';

export const SET_EDIT = 'SET_EDIT';
export const SET_EDIT_SUCCESS = 'SET_EDIT_SUCCESS';
export const SET_EDIT_ERROR = 'SET_EDIT_ERROR';

export const BATCH_REMOVE_FROM_SET = 'BATCH_REMOVE_FROM_SET';
export const BATCH_REMOVE_FROM_SET_SUCCESS = 'BATCH_REMOVE_FROM_SET_SUCCESS';
export const BATCH_REMOVE_FROM_SET_ERROR = 'BATCH_REMOVE_FROM_SET_ERROR';
